export const quick_start_data = [
  {
    name: 'marketing-portfolio-brand',
    alias: 'Marketing, Portfolio & Brand',
    description: 'Mauris elementum quam eu scelerisque imperdiet.',
    is_searchable: true,
    is_visible: true,
    icon: 'icons/sales_performance.svg',
    order: 1,
    data: [
      {
        question:
          'How does the mix of renovation, innovation and simplification impact 1, 2 and 3 year PPA KPIs?',
        is_visible: true,
        page_embed_url:
          'https://app.powerbi.com/reportEmbed?reportId=1ba09102-48aa-48f9-b16f-d363c0b5538b&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6&filterPaneEnabled=false&navContentPaneEnabled=false&pageName=ReportSectiona15e5ac65cbd0306e840',
        page_route_url: '/srm/elasticity/base-price-elasticity',
        page_name: 'renovation-impact',
        page_alias: 'Renovation Impact',
        page_icon: '',
        page_prefix: 'See'
      },
      {
        question: 'Are any of your brands in between price tiers?',
        is_visible: true,
        page_embed_url: '',
        page_route_url: '/srm/simulator/:id/pricing-distribution',
        page_name: 'pricing_and_distribution',
        page_alias: 'Pricing & Distribution',
        page_icon: '',
        page_prefix: 'See'
      },
      {
        question:
          'What is the financial impact of the recommended changes and their growth contribution by brand?',
        is_visible: true,
        page_embed_url:
          'https://app.powerbi.com/reportEmbed?reportId=fa1bb5b6-37ea-4d46-9270-30a5410a2e42&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6&filterPaneEnabled=false&navContentPaneEnabled=false&pageName=ReportSection3de773c62f86909bdd5d',
        page_route_url: '/srm/ppa/ppa-strategy-map',
        page_name: 'ppa-strategy-map',
        page_alias: 'PPA Strategy Map',
        page_icon: '',
        page_prefix: 'See'
      },
      {
        question:
          'Are there significant price / pack points where Mars isnt present?',
        is_visible: true,
        page_embed_url:
          'https://app.powerbi.com/reportEmbed?reportId=1ba09102-48aa-48f9-b16f-d363c0b5538b&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6&filterPaneEnabled=false&navContentPaneEnabled=false&pageName=ReportSectione673dca007e84035d1dc',
        page_route_url: '/srm/ppa/price-point-coverage',
        page_name: 'price-point-coverage',
        page_alias: 'Price Point Coverage',
        page_icon: '',
        page_prefix: 'See'
      },
      {
        question:
          'What is the relative impact of price changes vs. unit size change across volume and MAC?',
        is_visible: true,
        page_embed_url:
          'https://app.powerbi.com/reportEmbed?reportId=1ba09102-48aa-48f9-b16f-d363c0b5538b&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6&filterPaneEnabled=false&navContentPaneEnabled=false&pageName=ReportSection3dc7142f349a5120b644',
        page_route_url: '/srm/ppa/price-tier',
        page_name: 'price-tier',
        page_alias: 'Price Tier',
        page_icon: '',
        page_prefix: 'See'
      },
      {
        question: 'Are we growing the profitable parts of our portfolio?',
        is_visible: true,
        page_embed_url:
          'https://app.powerbi.com/reportEmbed?reportId=fa1bb5b6-37ea-4d46-9270-30a5410a2e42&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6&filterPaneEnabled=false&navContentPaneEnabled=false&pageName=ReportSection88a9b34107ff286aedf7',
        page_route_url: '/srm/ppa/price-pack-coverage',
        page_name: 'price-pack-coverage',
        page_alias: 'Price Pack Coverage',
        page_icon: '',
        page_prefix: 'See'
      }
    ]
  },
  {
    name: 'salesmarket',
    alias: 'Sales/Market',
    description: 'Ut ultricies nulla eu ullamcorper porttitor.',
    is_searchable: true,
    is_visible: true,
    icon: 'icons/pricing.svg',
    order: 2,
    data: [
      {
        question: 'Are any of your brands in between price tiers?',
        is_visible: true,
        page_embed_url:
          "https://app.powerbi.com/reportEmbed?reportId=81e75a1d-8977-48b4-8f8f-d6709bf8b7e2&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6&$filter=dim_country/country_code eq 'NL'&filterPaneEnabled=false&navContentPaneEnabled=false&pageName=ReportSectione75dd77b15c3080260a5",
        page_route_url:
          '/sales-performance-and-drivers/performance-summary/category-landscape',
        page_name: 'category-landscape',
        page_alias: 'Category Landscape',
        page_icon: '',
        page_prefix: 'See'
      },
      {
        question:
          'Are there significant price / pack points where Mars isnt present?',
        is_visible: true,
        page_embed_url:
          'https://app.powerbi.com/reportEmbed?reportId=1ba09102-48aa-48f9-b16f-d363c0b5538b&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6&filterPaneEnabled=false&navContentPaneEnabled=false&pageName=ReportSection0cf01baf5b2f88c60a34',
        page_route_url:
          '/sales-performance-and-drivers/sales-drivers/sales-trend-analysis',
        page_name: 'sales_trend_analysis',
        page_alias: 'Sales Trend Analysis',
        page_icon: '',
        page_prefix: 'See'
      },
      {
        question: 'Are we growing the profitable parts of our portfolio?',
        is_visible: true,
        page_embed_url:
          'https://app.powerbi.com/reportEmbed?reportId=fa1bb5b6-37ea-4d46-9270-30a5410a2e42&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6&filterPaneEnabled=false&navContentPaneEnabled=false&pageName=ReportSection863207f0226ebc187a05',
        page_route_url:
          '/sales-performance-and-drivers/sales-drivers/yoy-attribution',
        page_name: 'yoy-attribute',
        page_alias: 'YoY Attribution',
        page_icon: '',
        page_prefix: 'See'
      }
    ]
  },
  {
    name: 'srm',
    alias: 'SRM',
    description: 'Sed vel erat maximus, efficitur ipsum vel, faucibus quam.',
    is_searchable: true,
    is_visible: true,
    icon: 'icons/elasticity.svg',
    order: 3,
    data: [
      {
        question:
          'Which retailers compete in price for a given PPG & how they compare?',
        is_visible: true,
        page_embed_url: '',
        page_route_url: '',
        page_name: 'sale-and-performances',
        page_alias: 'Sales Performance And Drivers',
        page_icon: 'sales_performance',
        page_prefix: 'See'
      },
      {
        question:
          'Do I have the right incentives for consumers to buy specific sizes?',
        is_visible: true,
        page_embed_url: '',
        page_route_url: '',
        page_name: 'elasticity',
        page_alias: 'Elasticity',
        page_icon: 'elasticity',
        page_prefix: 'See'
      },
      {
        question: 'Which PPGs are prime for price actions?',
        is_visible: true,
        page_embed_url:
          'https://app.powerbi.com/reportEmbed?reportId=1ba09102-48aa-48f9-b16f-d363c0b5538b&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6&filterPaneEnabled=false&navContentPaneEnabled=false&pageName=ReportSectionc05d82b883357860e1cd',
        page_route_url: '/srm/pricing/price-slope-and-curve',
        page_name: 'price-slope',
        page_alias: 'Price Slope & Curve',
        page_icon: '',
        page_prefix: 'See'
      }
    ]
  },
  {
    name: 'category-leadership',
    alias: 'Category Leadership',
    description: 'Aliquam at arcu eu urna maximus tristique sit amet non diam.',
    is_searchable: true,
    is_visible: true,
    icon: 'icons/ppa.png',
    order: 4,
    data: [
      {
        question:
          'Praesent ac nunc euismod, auctor lorem sit amet, pharetra turpis.',
        is_visible: true,
        page_embed_url: '',
        page_route_url: '/srm/simulator/:id/planner-simulator',
        page_name: 'planner_simulator',
        page_alias: 'Planner & Simulator',
        page_icon: '',
        page_prefix: 'See'
      },
      {
        question: 'Phasellus bibendum libero eu tincidunt aliquet.',
        is_visible: true,
        page_embed_url: '',
        page_route_url: '/srm/simulator/:id/summary',
        page_name: 'summary',
        page_alias: 'Summary',
        page_icon: '',
        page_prefix: 'See'
      },
      {
        question:
          'Cras lobortis purus vitae orci aliquam, sit amet dapibus neque molestie.',
        is_visible: true,
        page_embed_url: '',
        page_route_url: '/srm/simulator/:id/renovation',
        page_name: 'renovation',
        page_alias: 'Renovation',
        page_icon: '',
        page_prefix: 'See'
      }
    ]
  }
];
